import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface SimulationStateInterface {
  simulating: boolean;
}

const initialState: SimulationStateInterface = {
  simulating: false,
};

const simulationSlice = createSlice({
  name: 'simulationState',
  initialState,
  reducers: {
    setSimulating(state, action: PayloadAction<boolean>) {
      state.simulating = action.payload;
    },
  },
});

export const { setSimulating } = simulationSlice.actions;

export const simulationReducer = simulationSlice.reducer;
